import fetchPub from '@/common/utils/serFetch'
import { GATEWAYSER } from '@/common/config/index'

const moduleList = {
  ruleModel: `${GATEWAYSER.SQSQT}/ruleModel`, // 模型管理
  ruleModelGroup: `${GATEWAYSER.SQSQT}/ruleModelGroup`, // 模型分类
  task: `${GATEWAYSER.SQSQT}/task` // 预览查看

}
// 质检系统-模型管理
export const modelMangeApi = {
  reqList: reqData => fetchPub.post(`${moduleList.ruleModel}/page`, reqData),
  reqOnline: reqData => fetchPub.post(`${moduleList.ruleModel}/online`, reqData),
  reqOffline: reqData => fetchPub.post(`${moduleList.ruleModel}/offline`, reqData),
  reqDelALL: reqData => fetchPub.post(`${moduleList.ruleModel}/delete`, reqData),
  reqDel({ id }) {
    return fetchPub.post(`${moduleList.ruleModel}/delete`, { ids: [id] })
  },
  reqGroup: reqData => fetchPub.post(`${moduleList.ruleModelGroup}/list`, reqData),
  // 下放
  reqDown: reqData => fetchPub.post(`${moduleList.ruleModel}/down`, reqData),
  // 回收
  reqUp: reqData => fetchPub.post(`${moduleList.ruleModel}/up`, reqData),
  reqExcel(reqData) {
    return fetchPub.post(`${moduleList.ruleModel}/export`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
  }
}
// 质检系统-模型分类
export const modelGroupApi = {
  reqList: reqData => fetchPub.post(`${moduleList.ruleModelGroup}/page`, reqData),
  reqAdd: reqData => fetchPub.post(`${moduleList.ruleModelGroup}/add`, reqData),
  reqUpdate: reqData => fetchPub.post(`${moduleList.ruleModelGroup}/edit`, reqData.newData),
  reqDelALL: reqData => fetchPub.post(`${moduleList.ruleModelGroup}/delete`, reqData),
  reqDel({ id }) {
    return fetchPub.post(`${moduleList.ruleModelGroup}/delete`, { ids: [id] })
  },
  reqView(reqData) {
    return fetchPub.post(`${moduleList.task}/view`, reqData)
  }
}

